import angular from 'angular';
import template from './template.html';
import _ from 'lodash';
import EnvSettings from '../../../../../../config/settings';

export class editAssociatedEmployerRepModalCtrl {
    /* @ngInject */
    constructor(
        $scope,
        $localStorage,
        EmployerRepService,
    ) {

        this.$scope = $scope;
        this.$localStorage = $localStorage;
        this.EmployerRepService = EmployerRepService;
        this.EnvSettings = EnvSettings;
    }

    async $onInit() {
        this.isLoading = true;
        const currentEmployerId = this.resolve.employerId;
        const associatedEmployerRepId = this.resolve.associatedEmployerRepId;

        const { result: employerReps } = await this.EmployerRepService.getEmployersRepSearch({ employerId: currentEmployerId });

        if (!employerReps.length) {
            const message = this.$localStorage.UILanguage['UPDATE_EMPLOYER_REP_NO_REP_MESSAGE'];

            this.message = message.replace(
                new RegExp('<a>', 'g'),
                `<a href='${this.EnvSettings.Auth0RedirectUrl}#/employer/${currentEmployerId}/manageUsers' target="_blank">`,
            );
        } else {
            const sortedEmployers = _.sortBy(employerReps, 'name');

            this.selectedEmplRep = _.find(sortedEmployers, { _id: associatedEmployerRepId }) || _.first(sortedEmployers);
            this.employerReps = sortedEmployers;
        }

        this.isLoading = false;
        this.$scope.$apply();
    }

    save() {
        this.modalInstance.close(this.selectedEmplRep._id);
    }

    close() {
        this.modalInstance.dismiss();
    }
}

export const editAssociatedEmployerRepModalCtrlConfiguration = {
    controller: editAssociatedEmployerRepModalCtrl,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
    template,
};

angular
    .module('TALENYA-FE')
    .component('editAssociatedEmployerRepModalCtrl', editAssociatedEmployerRepModalCtrlConfiguration);
